"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadFile;

function loadFile(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = function (loadedFile) {
      return resolve(loadedFile.target.result);
    };

    reader.onerror = function () {
      return reject(new Error('There was an error uploading the file'));
    };
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/ImagePicker/load-file.js
// module id = ./node_modules/quark-web/components/form/ImagePicker/load-file.js
// module chunks = 0